<template>
  <div class="animated fadeIn margin-top-30">
    <GeneralSpinner v-if="spinner_systems"></GeneralSpinner>
    <div class="row" v-else="">
      <div class="col-sm-6 col-md-4 col-xl-3" v-for="system in systems">
        <div class="card border-primary">
          <div class="card-header text-center">
            {{system.name}}
          </div>
          <div class="card-body">
            <gmap-map id="mapsystem" :center="{lat:parseFloat(system.coordinates.split('#')[0]), lng:parseFloat(system.coordinates.split('#')[1])}" :zoom="9" map-type-id="hybrid">
              <gmap-marker :position="{lat:parseFloat(system.coordinates.split('#')[0]), lng:parseFloat(system.coordinates.split('#')[1])}">
              </gmap-marker>
            </gmap-map>
          </div>
          <div class="card-footer">
            <div class="row flex-nowrap">
              <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                <button type="button" class="btn btn-outline-primary btn-block" @click="selectSystem(system)">
                  <i class="fa fa-bullseye"></i> {{web_texts.select}}
                </button>
              </div>
              <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <!--<button type="button" class="btn btn-outline-danger btn-block">-->
                <button type="button" class="btn btn-outline-success btn-block" @click="goNotifications(system)">
                  <i class="fa fa-bell-o"></i>
                  <!--<span class="badge badge-pill badge-danger">1</span>-->
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/SelectSystem';
  import trans_es from '../translates/es/SelectSystem';
  import constants from '../constants'
  import middleware from '../utilities/middlewares'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: 'SelectSystem',
    data() {
      return {
        web_texts: { "select": "Seleccionar" },
        systems: '',
        spinner_systems: true,
      }
    },
    created() {
      window.localStorage.removeItem('system');
      window.localStorage.setItem('real_time_control', '["select_system","select_system"]');
      middleware.userIsLoged();
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      this.getSystems();
      this.getUser();
    },
    components:{
      GeneralSpinner
    },
    watch: {
      '$route'(to, from) {
        window.localStorage.removeItem('system');
      }
    },
    methods: {
      // Llegir l'usuari i si es correcte mostrar els sistemes
      getUser(){
        axios.post(constants.ROOT_URL + '/api/v1/get_user')
          .then((response) => {
            window.localStorage.setItem('user', JSON.stringify(response.data));
            this.spinner_systems=false;
          }, (response) => {
            console.log(response.data);
            middleware.tokenValidCalls(response, this);
          });
      },
      // Llegir tots els sistemes
      getSystems() {
        axios.get(constants.ROOT_URL + '/api/v1/get_systems_and_clients_by_user')
          .then((response) => {
            if (response.data.length === 1) {
              console.log(response.data[0]);
              window.localStorage.setItem('system', JSON.stringify(response.data[0]));
              this.$router.push('home');
            }
            this.systems = response.data;
          }, (response) => {
            console.log(response.data);
            middleware.tokenValidCalls(response, this);
          });
      },
      // Anar a la home del sistema seleccionat
      selectSystem(system) {
        window.localStorage.setItem('system', JSON.stringify(system));
        this.$router.push('home');
      },
      // Anar a les notificacions del sistema seleccionat
      goNotifications(system){
        window.localStorage.setItem('system', JSON.stringify(system));
        this.$router.push('notifications');
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .margin-top-30 {
    margin-top: 30px;
  }
  #mapsystem {
    height: 200px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// SelectSystem.vue?4e93103b